import { Component, OnInit, ViewChild } from '@angular/core';
import * as moment from 'moment';
import { forkJoin } from 'rxjs';
import { Currency } from '../currency';
import { HttpService } from '../service/http.service';
import { SchoolInvoiceWithPaymentOrdersListItem } from '../school-invoice-with-payment-orders-list-item';
import { SelectItem } from 'primeng/api';
import { Table } from 'primeng/table';

@Component({
  selector: 'app-all-invoices',
  templateUrl: './all-invoices.component.html',
  styleUrls: ['./all-invoices.component.css']
})
export class AllInvoicesComponent implements OnInit {
  @ViewChild("invTable") table!: Table;

  invoices: SchoolInvoiceWithPaymentOrdersListItem[] = [];
  years: SelectItem[] = [];
  selectedYear!: string;
  comments: SelectItem[] = [];
  selectedComments: string[] = [];
  schoolNames: SelectItem[] = [];
  selectedSchoolNames: string[] = [];
  currencyIsoCodes: SelectItem[] = [];
  selectedCurrencyIsoCodes: string[] = [];
  cols = [
    { field: "id", header: "Booking ID" },
    { field: "invoiceNumber", header: "Inv. number" },
    { field: "school.name", header: "School" },
    { field: "studentName", header: "Student" },
    { field: "invoiceAmount", header: "Inv. amt" },
    { field: "dueDate", header: "Due date" },
    { field: "currency.isoCode", header: "Currency" },
    { field: "invoiceDate", header: "Inv. date" },
    { field: "comment", header: "Comment" },
    { field: "totalPaidAmount", header: "Paid amt" },
    { field: "lastPaymentDate", header: "Paid date" },
    { field: "balance", header: "Balance" }
  ];

  constructor(
    private httpService: HttpService
  ) { }

  ngOnInit(): void {
    let currentYearStr = moment().format("YYYY");
    this.years[0] = { label: currentYearStr, value: currentYearStr };
    this.selectedYear = currentYearStr;
    this.httpService.getSchoolInvoiceYears().subscribe(res => {
      let years: SelectItem[] = [];
      for (let year of res) {
        years.push({ label: year, value: year });
      }
      this.years = years;
    });
    forkJoin({
      invoices: this.httpService.getSchoolInvoicesWithPaymentByYear(this.selectedYear),
      currencies: this.httpService.getCurrencies()
    }).subscribe(({ invoices, currencies }) => {
      this.setCurrencyIsoCodes(currencies);
      this.configFilters(invoices);
    });
  }

  setCurrencyIsoCodes(currencies: Currency[]) {
    this.currencyIsoCodes = [];
    for (let currency of currencies) {
      this.currencyIsoCodes.push({ label: currency.isoCode, value: currency.isoCode });
    }
  }

  downloadCsv(){
    let csvStr = "BNP?,booking id,due date,student,school,amount,paid amount\n";
    for(let invoice of this.invoices){
      let type: string = invoice.isElb?"BNP":"ING";
      csvStr = csvStr + type + "," + invoice.bookingId + "," + invoice.dueDate + "," + invoice.studentName + "," + invoice.school.name + "," + invoice.invoiceAmount + "," + invoice.totalPaidAmount + "\n";
    }
    let downloadLink = document.createElement('a');
    downloadLink.href = window.URL.createObjectURL(new Blob([csvStr], { type: 'text/csv' }));
    downloadLink.setAttribute('download', "invoices.csv");
    document.body.appendChild(downloadLink);
    downloadLink.click();
  }


  configFilters(invoices: SchoolInvoiceWithPaymentOrdersListItem[]) {
    this.invoices = invoices;
    this.sortComments(invoices);
    this.sortSchoolNames(invoices);
  }

  sortSchoolNames(invoices: SchoolInvoiceWithPaymentOrdersListItem[]) {
    this.schoolNames = [];
    this.selectedSchoolNames = [];
    let schoolNames: Set<string> = new Set();
    for (let invoice of invoices) {
      schoolNames.add(invoice.school.name);
    }
    let sortedSchoolNames = Array.from(schoolNames).sort((a, b) => {
      return a.localeCompare(b);
    });
    sortedSchoolNames.forEach(str => {
      this.schoolNames.push({ label: str, value: str });
      this.selectedSchoolNames.push(str);
    });
  }

  sortComments(invoices: SchoolInvoiceWithPaymentOrdersListItem[]) {
    this.comments = [];
    this.selectedComments = [];
    let comments: Set<string> = new Set();
    for (let invoice of invoices) {
      if (invoice.comment == null) {
        invoice.comment = "";
      }
      comments.add(invoice.comment);
    }
    let sortedComemnts = Array.from(comments).sort((a, b) => {
      return a.localeCompare(b);
    });
    sortedComemnts.forEach(str => {
      this.comments.push({ label: str, value: str });
      this.selectedComments.push(str);
    });
  }

  updateInvoices() {
    this.httpService.getSchoolInvoicesWithPaymentByYear(this.selectedYear).subscribe(res => {
      this.configFilters(res);
    });
  }

  downloadInvoiceFile(invoice: SchoolInvoiceWithPaymentOrdersListItem) {
    this.httpService.getSchoolInvoiceFileById(invoice.fileId).subscribe(res => {
      let binaryData = [];
      binaryData.push(res);
      this.downloadFile(binaryData, invoice.fileName);
    });
  }

  downloadFile(bytes: BlobPart[], fileName: string) {
    let downloadLink = document.createElement('a');
    downloadLink.href = window.URL.createObjectURL(new Blob(bytes, { type: 'blob' }));
    downloadLink.setAttribute('download', fileName);
    document.body.appendChild(downloadLink);
    downloadLink.click();
  }

}